import { setSpecificMessage, hash } from "valibot";
setSpecificMessage(
  hash,
  (issue) => `Hash invalide: reçu ${issue.received}`,
  "fr"
);